import { PointRenderStrategy } from "./D3PointRenderStrategy"

export class IntermittentMedicationRenderStrategy extends PointRenderStrategy {
    protected isMissingValue = (value: number | null) => value === null || value <= 0
}
